/**
 * DO NOT remove! This is needed to make sure different user interaction events
 * occurring in quick succession are pushed to a single list, to be sent to telemetry after
 * the default period of inactivity (2.5 s)
 * @type {number}
 */
let sharedTimeoutId;

/**
 * Convert a normal function to a 'debounced' function using a shared timeout id
 * @param {function} func Function to be debounced
 * @param {number} delay Time delay after which the function should actually execute
 * @param {object} context Object to which 'this' in 'func' should point to
 * @returns {function} Debounced function using shared timeoutId
 */
export const sharedDebounce = (func, delay, context = this) => {
	return (...args) => {
		if (sharedTimeoutId) clearTimeout(sharedTimeoutId);
		sharedTimeoutId = setTimeout(() => {
			func.apply(context, args);
		}, delay);
	};
};
